export default {
  pagination: {},
  newProduct: {},
  product: null,
  products: [],
  coupons: [],
  categories: [],
  frequencyOptions: [
    { id: "weekly", months: 0.25, name: "Semanal" },
    { id: "monthly", months: 1, name: "Mensal" },
    { id: "bimonthly", months: 2, name: "Bimestral" },
    { id: "quarterly", months: 3, name: "Trimestral" },
    { id: "half-yearly", months: 6, name: "Semestral" },
    { id: "yearly", months: 12, name: "Anual" }
  ],
  warranties: [
    { id: 7, name: "7 dias" },
    { id: 15, name: "15 dias" },
    { id: 21, name: "21 dias" },
    { id: 30, name: "30 dias" }
  ],
  currencies: [],
  paymentMethods: [],
  students: [],
  coupon: {}
};
